<div class="access-card" [class.expanded]="expanded">
  <div class="card-header" (click)="toggleExpanded()">
    <div class="card-title">
      <div class="title-icon" [class.success]="successfullyConnected">
        <i *ngIf="successfullyConnected" class="fa-solid fa-check"></i>
        <i *ngIf="!successfullyConnected && accessType === 'source'" class="fa-solid fa-location-dot"></i>
        <i *ngIf="!successfullyConnected && accessType === 'target'" class="fa-solid fa-location-crosshairs"></i>
        <i *ngIf="!successfullyConnected && accessType === 'failback'" class="fa-solid fa-rotate-left"></i>
      </div>
      <div>
        <h3>{{ title }}</h3>
        <div class="card-subtitle">
          <code>{{ subscriptionId }}</code> / <code>{{ region }}</code>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <div class="card-action" (click)="$event.stopPropagation()">
        <ng-container *ngIf="successfullyConnected; else notSuccessBlock">
          <span class="success-badge"><i class="fa-solid fa-circle-check"></i> Connected</span>
        </ng-container>
        <ng-template #notSuccessBlock>
          <button class="arpio-button" [disabled]="testing" (click)="testButtonClick()">
            <ng-container *ngIf="testing; else notTestingBlock">
              <i class="fa-solid fa-spinner fa-spin"></i> TESTING...
            </ng-container>
            <ng-template #notTestingBlock>TEST ACCESS</ng-template>
          </button>
        </ng-template>
      </div>
      <i class="fa-solid chevron-icon" [class.fa-chevron-down]="expanded" [class.fa-chevron-right]="!expanded"></i>
    </div>
  </div>

  <div class="card-body-wrapper" *ngIf="!successfullyConnected" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
    <div class="card-body">
      <p class="instruction-text">
        <strong *ngIf="retryText" class="retry-text">{{ retryText }}</strong>
        Execute the following command to grant {{ uiService.productName }} access to your Azure subscription:
      </p>

      <div class="command-block">
        <button class="copy-btn" [copy-clipboard]="installCommand" (copied)="onCopied()">
          <i class="fa-utility fa-semibold" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
          {{ copied ? 'Copied!' : 'Copy' }}
        </button>
        <pre><code>{{ installCommand }}</code></pre>
      </div>
    </div>
  </div>

  <div class="card-body-wrapper" *ngIf="successfullyConnected" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
    <div class="card-body success-body">
      <div class="success-message">
        <i class="fa-solid fa-circle-check"></i>
        <span>Access configured successfully</span>
      </div>
    </div>
  </div>
</div>
